import { StyleSheet } from 'react-native';

import { Fonts } from '../Themes';

export default StyleSheet.create({
  title: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    lineHeight: 31.2,
    paddingHorizontal: 16,
  },
  itemContainerStyle: (theme, isActive) => ({
    borderRadius: 5,
    borderWidth: isActive ? 2 : 1,
    borderColor: isActive ? theme.colors.radioButton : theme.colors.optionBorderColor,
    justifyContent: 'center',
    alignItems: 'center',
  }),
  titleTextStyle: (theme, isActive) => ({
    fontSize: 18,
    ...(isActive ? Fonts.type.bold : { fontFamily: Fonts.type.VFFont }),
    color: theme.colors.textColorThree,
  }),
  subTitleTextStyle: theme => ({
    fontSize: 14,
    color: theme.colors.textColorTwo,
    marginTop: 1,
  }),
  description: {
    fontFamily: Fonts.type.VFFont,
    fontSize: 14.6,
    lineHeight: 18.7,
    paddingHorizontal: 16,
  },
});
